jQuery(document).ready(function ($) {
  jQuery(".question-box h2.question").click(function () {
    jQuery(this).next(".answer").slideToggle().toggleClass("showMe");
    jQuery(this).find("i.bt-plus-circle").toggleClass("bt-minus-circle");
  });

  // Bind Enter key to click this
  $(".question-box h2.question").keyup(function (e) {
    if (e.keyCode == 13) {
      $(this).click();
    }
  });
});
